import { render, staticRenderFns } from "./WFEndNode.vue?vue&type=template&id=0680e7ea&scoped=true"
import script from "./WFEndNode.vue?vue&type=script&lang=js"
export * from "./WFEndNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0680e7ea",
  null
  
)

export default component.exports